import { Routes } from '@angular/router';
import { authGuard, settingsAdminGuard } from '../../core/guards';

export const settingsRoutes: Routes = [
  {
    path: 'settings',
    loadComponent: () =>
      import('./components/settings.component').then((m) => m.SettingsComponent),
    canActivate: [authGuard, settingsAdminGuard],
  },
];
